import produce from 'immer';

// TYPES
import { Types, CadastrarFuncionalidade } from './types';
import { ReducerActionRotaSP } from '../../../../../types';

export const INITIAL_STATE: CadastrarFuncionalidade = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): CadastrarFuncionalidade {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CADASTRAR_FUNCIONALIDADE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.CADASTRAR_FUNCIONALIDADE_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CADASTRAR_FUNCIONALIDADE_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.CADASTRAR_FUNCIONALIDADE_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
